import type { ActivityTransport } from "src/activity/activityTracker";
import { API_PATHS } from "src/constants/api";

/** Same-origin POSTs; the visitor/session cookies identify the subject, never the payload. */
export const browserTransport: ActivityTransport = {
	send: async body => {
		const response = await fetch(API_PATHS.activity, {
			method: "POST",
			headers: { "content-type": "application/json" },
			credentials: "same-origin",
			keepalive: true,
			body
		});
		if (!response.ok && response.status >= 500) throw new Error(`Activity rejected: ${response.status}`);
	},
	beacon: body => {
		// text/plain keeps the beacon a "simple" request; the API parses the raw body.
		if (!navigator.sendBeacon?.(API_PATHS.activity, new Blob([body], { type: "text/plain" }))) {
			void fetch(API_PATHS.activity, { method: "POST", body, keepalive: true, credentials: "same-origin" });
		}
	}
};
